import React from 'react';
import { FlatButton, IconButton, SelectField, MenuItem } from 'material-ui';
import WidgetList from '../../editor/components/WidgetList';
import { connect } from 'react-redux';
import { compose, branch, renderComponent, renderNothing, lifecycle } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import EventCell from './EventCell';
import PlayerCell from './PlayerCell';

import { withLeagueWidgets, withTeamWidgets, withEventWidgets, withPlayerWidgets } from '../hoc/widgets';

const LeagueSelector = ({ onTabOpen, tournamentId, onLeagueSelected }) => (
    <div>
        <FlatButton
            label="Superliga"
            primary={tournamentId == 46}
            disabled={tournamentId == 46}
            onClick={() => {
                onLeagueSelected(46);
            }}
        />
        <FlatButton
            label="England"
            primary={tournamentId == 47}
            disabled={tournamentId == 47}
            onClick={() => {
                onLeagueSelected(47);
            }}
        />
    </div>
);

const LeagueSelectorEnchanced = withLeagueWidgets(LeagueSelector);

const Navigator = ({
    tab,
    tournamentId,
    teamId,
    seasonId,
    eventId,
    playerId,
    onLeagueSelected,
    onTeamSelected,
    onPlayerSelected,
    onEventSelected,
}) => (
    <div style={{ padding: 15, background: '#222222' }}>
        <LeagueSelectorEnchanced tournamentId={tournamentId} onLeagueSelected={onLeagueSelected} />
        <LeagueInfoEnchanced
            full={tab === 'league' || (tab === 'event' && !teamId)}
            eventId={eventId}
            onTeamSelected={onTeamSelected}
            onEventSelected={onEventSelected}
        />
        <TeamInfoEnchanced
            full={teamId}
            teamId={teamId}
            eventId={eventId}
            playerId={playerId}
            onEventSelected={onEventSelected}
            onPlayerSelected={onPlayerSelected}
        />

        <EventInfoEnchanced eventId={eventId} />
        <PleayerInfoEnchanced playerId={playerId} />
    </div>
);

Navigator.defaultProps = {
    wdpcache: 'state',
};

Navigator.propTypes = {
    onLeagueSelected: PropTypes.func.isRequired,
    onTeamSelected: PropTypes.func.isRequired,
    onEventSelected: PropTypes.func.isRequired,
    onPlayerSelected: PropTypes.func.isRequired,
    template: PropTypes.string.isRequired,
};

const TeamsList = compose(branch(({ teams = [] }) => teams.length === 0, renderNothing))(
    ({ title, teams, tournamentId, teamId, small, onTeamSelected }) => (
        <div>
            {teams.map(t => (
                <IconButton
                    key={t.id}
                    iconStyle={{
                        width: small ? 24 : 48,
                        height: small ? 24 : 48,
                        transition: 'all 0.5s ease',
                    }}
                    style={{
                        transition: 'all 0.5s ease',
                        width: small ? 48 : 72,
                        height: small ? 48 : 72,
                    }}
                >
                    <img
                        alt={t.name}
                        style={{
                            margin: 5,
                            transition: 'all 0.5s ease',
                            backgroundColor: +teamId == +t.id ? '#000' : 'transparent',
                        }}
                        onClick={() => onTeamSelected(tournamentId, t.id)}
                        src={`https://dxugi372p6nmc.cloudfront.net/wdp/current/original/${t.id}/teamlogo.png`}
                    />
                </IconButton>
                // <FlatButton
                //     primary={teamId == t.id}
                //     disabled={teamId == t.id}
                //     key={t.id}
                //     label={t.name}
                //     onClick={() => onTeamSelected(t.id)}
                // />
            ))}
        </div>
    ),
);

const NoWidgets = () => <div style={{ textAlign: 'center', padding: 15 }}> - No widgets - </div>;

const getEventInfo = e => {
    if (e.statusType === 'finished') return `FT ${e.homeShortName}-${e.awayShortName} ${e.score.home}:${e.score.away}`;
    if (e.statusType === 'inprogress')
        return `LIVE ${e.homeShortName}-${e.awayShortName} ${e.score.home}:${e.score.away}`;
    if (e.statusType === 'notstarted')
        return `${moment(e.startDate).format('HH:mm')} ${e.homeShortName}-${e.awayShortName}`;
    return `${e.homeShortName}-${e.awayShortName}`;
};
const MatchesList = compose(branch(({ events = [] }) => events.length === 0, renderNothing))(
    ({ title, events, eventId, withContextOf = {}, onEventSelected }) => (
        <div style={{ display: 'flex' }}>
            {events.map(e => (
                <EventCell
                    key={e.eventId}
                    active={+e.eventId === +eventId}
                    {...e}
                    onClick={() => onEventSelected(e.eventId, withContextOf)}
                />
            ))}
        </div>
    ),
);

const LeagueInfo = ({
    tournament,
    teamId,
    eventId,
    lastMatches = [],
    nextMatches = [],
    teams = [],
    onEventSelected,
    onTeamSelected,
    full = true,
}) => (
    <div>
        {tournament && (
            <TeamsList teams={teams} small={!full} tournamentId={tournament.id} onTeamSelected={onTeamSelected} />
        )}
        {full && (
            <MatchesList eventId={eventId} title="Finished" events={lastMatches} onEventSelected={onEventSelected} />
        )}
        {full && (
            <MatchesList eventId={eventId} title="Upcoming" events={nextMatches} onEventSelected={onEventSelected} />
        )}
    </div>
);

const EventInfo = branch(({ event }) => !event, renderNothing)(({ tournament, event }) => (
    <div>
        <h1>
            {event.homeName}-{event.awayName}
        </h1>
    </div>
));
const EventInfoEnchanced = connect(({ widgetPicker }) => ({
    ..._.get(widgetPicker, `info.event`, {}),
}))(withEventWidgets(EventInfo));

const TeamInfo = branch(({ team }) => !team, renderNothing)(
    ({
        team,
        members: { players = [], coach = [] } = {},
        topPlayers = [],
        lastMatches = [],
        nextMatches = [],
        teams = [],
        eventId,
        playerId,
        onEventSelected,
        onPlayerSelected,
        full = true,
    }) => (
        <div>
            <h1 style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    alt={team && team.name}
                    style={{
                        width: 36,
                        margin: 5,
                        marginRight: 15,
                    }}
                    src={`https://dxugi372p6nmc.cloudfront.net/wdp/current/original/${team.id}/teamlogo.png`}
                />
                {(team && team.name) || 'TEAM INFO'}
            </h1>
            {full && (
                <MatchesList
                    title="Matches"
                    eventId={eventId}
                    withContextOf={{ teamId: team.id }}
                    events={[...lastMatches, ...nextMatches]}
                    onEventSelected={onEventSelected}
                />
            )}

            <h5>Top players</h5>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {topPlayers.map(p => (
                    <PlayerCell
                        key={p.id}
                        {...p}
                        active={p.id === playerId}
                        onClick={() => onPlayerSelected(team.id, p.id)}
                    />
                ))}
                <SelectField
                    floatingLabelText="Find player"
                    style={{
                        backgound: '#222',
                        margin: 5,
                    }}
                    floatingLabelFixed
                    value={playerId}
                    onChange={(e, pId) => {
                        onPlayerSelected(team.id, pId);
                    }}
                >
                    {_.orderBy(players, p => -_.get(p, 'stats.minutesPlayed', 0)).map(p => (
                        <MenuItem
                            value={p.id}
                            key={p.id}
                            primaryText={p.name}
                            onClick={() => onPlayerSelected(team.id, p.id)}
                        />
                    ))}
                </SelectField>
            </div>
        </div>
    ),
);

const PlayerInfo = branch(({ player }) => !player, renderNothing)(({ player }) => <h1>{player.name}</h1>);

const LeagueInfoEnchanced = connect(({ widgetPicker }) => ({
    ..._.get(widgetPicker, `info.league`, {}),
}))(LeagueInfo);

const TeamInfoEnchanced = connect(({ widgetPicker }) => ({
    ..._.get(widgetPicker, `info.team`, {}),
}))(withTeamWidgets(TeamInfo));

const PleayerInfoEnchanced = connect(({ widgetPicker }) => ({
    ..._.get(widgetPicker, `info.player`, {}),
}))(withPlayerWidgets(PlayerInfo));

const NavigatorEnchanced = compose(
    connect(({ widgetPicker }, props) => {
        return {
            tournamentId: props.tournamentId || _.get(widgetPicker, 'info.team.team.mainTournamentId'),
        };
    }),

    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {},
    }),
)(Navigator);

export default NavigatorEnchanced;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/components/Navigator.js
 **/